export default __webpack_public_path__ + "assets/img/yota.f4e946b.png";